:host {
  /* Other */
  --input-direction: var(--jb-national-input-input-direction, ltr);
}
